import { useEffect } from 'react';
import * as React from 'react';
import { shape, bool } from 'prop-types';
import { CurrencyField, SelectField, CheckboxField, SplitDateField, RadioSwitchFields } from 'shared/fields';
import { Info, Heading, LabelText } from 'shared/components';
import { InputsContainer, FlexContainer} from 'shared/containers';
import analytics from 'shared/utility/analytics';
import { Hyperlink } from 'shared/buttons';
import { periodOptions } from 'shared/config';
import { useNavigate } from "react-router-dom";

const ApplicantForm = ({ values: { applicant_is_entrepreneur, applicant_showPension }, settings: {entrepreneursModule}}) => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate('/hypotheekbespaarcheck/applicant-form');
  }, [navigate]);

  useEffect(() => analytics.send('Navigeer', 'applicant-form'), []);
  return (
    <>
      <Heading>Je gegevens</Heading>
      <InputsContainer>
        <LabelText>Je geboortedatum</LabelText>
        <SplitDateField name="applicant_dob" />

        {entrepreneursModule ? (
          <>
            <LabelText>
              Ben je ondernemer?
              <Info title="Ben je ondernemer?">
                Voor de berekening van je toetsinkomen hebben we de nettowinst van de afgelopen 3 kalenderjaren nodig (jaar
                3 is het meest recente volledige kalenderjaar).
              </Info>
            </LabelText>
            <RadioSwitchFields name="applicant_is_entrepreneur" />

            {!!applicant_is_entrepreneur && (
              <React.Fragment>
                <LabelText>Nettowinst {new Date().getFullYear() - 3}</LabelText>
                <CurrencyField name="applicant_entrepreneur_fiscal_profit_three_years_ago" placeholder="Bedrag" />
                <LabelText>Nettowinst {new Date().getFullYear() - 2}</LabelText>
                <CurrencyField name="applicant_entrepreneur_fiscal_profit_two_years_ago" placeholder="Bedrag" />
                <LabelText>Nettowinst {new Date().getFullYear() - 1}</LabelText>
                <CurrencyField name="applicant_entrepreneur_fiscal_profit_last_year" placeholder="Bedrag" />
              </React.Fragment>
            )}
            </>
          ) : null}

        {!applicant_is_entrepreneur && (
          <React.Fragment>
            <LabelText>Wat is je bruto inkomen?</LabelText>
            <FlexContainer>
              <CurrencyField name="applicant_income" placeholder="Bedrag" />
              <SelectField
                id="applicant_income_period"
                name="applicant_income_period"
                options={periodOptions}
                placeholder="Per"
              />
            </FlexContainer>
            <FlexContainer>
              <CheckboxField id="applicant_holiday_bonus" name="applicant_holiday_bonus" label="Vakantiegeld?" />
              <CheckboxField id="applicant_13th_month_salary" name="applicant_13th_month_salary" label="13e maand?" />
            </FlexContainer>
          </React.Fragment>
        )}
        {applicant_showPension && (
          <React.Fragment>
            <LabelText>
              Je bruto jaarinkomen na AOW datum (inclusief AOW)
              <Info title="Hoogte pensioen en AOW">
                Op <Hyperlink href="https://www.mijnpensioenoverzicht.nl/">mijnpensioenoverzicht.nl</Hyperlink> vind je
                informatie over je AOW en je pensioen via al je werkgevers (oud en nieuw). Let op: je vindt hier geen
                informatie over een aanvullend pensioen dat je zelf hebt geregeld.
              </Info>
            </LabelText>
            <FlexContainer>
              <CurrencyField name="applicant_pension_income" placeholder="Bedrag" />
              <SelectField
                id="applicant_pension_income_period"
                name="applicant_pension_income_period"
                options={periodOptions}
                placeholder="Per"
              />
            </FlexContainer>
          </React.Fragment>
        )}
      </InputsContainer>
    </>
  );
};
ApplicantForm.propTypes = {
  values: shape({
    applicant_is_entrepreneur: bool,
    applicant_is_entrepreneur_for_three_years: bool,
    applicant_showPension: bool,
  }).isRequired,
};

export default ApplicantForm;
